
import React, { memo } from 'react';

interface TrashProps {
	onClick?: any
	color?: string;
}

export default memo(function close(props:TrashProps) {
	return (
		<svg version="1.1" id="Layer_1" width="30px" height="24px" viewBox="0 0 48 48">
			<g fill={props.color ? props.color : '#888'}>
				<path d="M36.2,15.6c-0.7,0-1.2,0.6-1.2,1.2v23.8H13.4V16.8c0-0.7-0.6-1.2-1.2-1.2s-1.2,0.6-1.2,1.2v25.1
					c0,0.7,0.6,1.2,1.2,1.2h24c0.7,0,1.2-0.6,1.2-1.2V16.8C37.4,16.2,36.9,15.6,36.2,15.6z"></path>
				<path d="M38.2,9.7h-8V6.1c0-0.7-0.6-1.2-1.2-1.2h-9.6c-0.7,0-1.2,0.6-1.2,1.2v3.6h-7.9c-0.7,0-1.2,0.6-1.2,1.2
					s0.6,1.2,1.2,1.2h28c0.7,0,1.2-0.6,1.2-1.2S38.9,9.7,38.2,9.7z M20.6,9.7V7.3h7.1v2.3H20.6z"></path>
				<path d="M25.5,36V19.4c0-0.7-0.6-1.2-1.2-1.2S23,18.7,23,19.4V36c0,0.7,0.6,1.2,1.2,1.2S25.5,36.7,25.5,36z"></path>
				<path d="M30.2,36V19.4c0-0.7-0.6-1.2-1.2-1.2s-1.2,0.6-1.2,1.2V36c0,0.7,0.6,1.2,1.2,1.2S30.2,36.7,30.2,36z"></path>
				<path d="M20.6,36V19.4c0-0.7-0.6-1.2-1.2-1.2s-1.2,0.6-1.2,1.2V36c0,0.7,0.6,1.2,1.2,1.2S20.6,36.7,20.6,36z"></path>
			</g>
		</svg>
		
	);
});
